import { render, staticRenderFns } from "./LabeledValue.vue?vue&type=template&id=10f080d6&scoped=true&"
import script from "./LabeledValue.vue?vue&type=script&lang=ts&"
export * from "./LabeledValue.vue?vue&type=script&lang=ts&"
import style0 from "./LabeledValue.vue?vue&type=style&index=0&id=10f080d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f080d6",
  null
  
)

export default component.exports